export const LIST_PROMO_CODES= ' LIST_PROMO_CODES';
export const LIST_PROMO_CODES_LOADING = ' LIST_PROMO_CODES_LOADING';